import * as firebase from 'firebase/app';
import 'firebase/firestore'
import 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyBTvqLqfjJICe1sSqB28yOwZC3l_ZELwjk",
    authDomain: "sanchoai.firebaseapp.com",
    databaseURL: "https://sanchoai.firebaseio.com",
    projectId: "sanchoai",
    storageBucket: "sanchoai.appspot.com",
    messagingSenderId: "339411100305",
    appId: "1:339411100305:web:cec6e2520dec1bd5f45530",
    measurementId: "G-ZHJ9Q0899G"
  };
firebase.initializeApp(firebaseConfig);

// Get a Firestore instance
export const db = firebase.firestore()

// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
const { Timestamp, GeoPoint } = firebase.firestore

// App types
type Keyword = {
    name: string;
    frequency: number;
}

type Campaign = {
    id: string;
    name: string;
    url: string;
    creatorId: string;
    websiteId?: number;
    scrappId: number;
    scraped: boolean;
    keywords: Keyword[] | null;
    keywordPlanners: KeywordPlanner[] | null;
    ads: Ad[] | null;
    description?: string;
    description2?: string;
    customerId?: number;
    done: boolean;
    step: number;
    selectedAds: Ad[] | null;
    selectedKeywords: Keyword[] | null;
    selectedPlanner: KeywordPlanner[] | null;
    campaignId?: string;
    status: boolean; 
}

type KeywordPlanner = {
    text: string;
    avgMonthlySearches: number;
    competitionValue: string;
}

type Ad = {
    url: string;
    headline1: string;
    headline2: string;
    campaignId: number;
    adGroupId: number;
}

export { Timestamp, GeoPoint, Keyword, Campaign, KeywordPlanner, Ad }
